/**
 * El texto que se le muestra a un administrador cuando una llamada falla.
 *
 * Estaba copiado identico en seis pantallas del backoffice. Vive aca porque el
 * criterio es uno solo y conviene cambiarlo en un lugar: si la API explico que
 * paso, se muestra su explicacion; si ni siquiera se pudo llegar al servidor
 * —que es lo que significa cualquier otro fallo— se dice eso y se invita a
 * reintentar, en vez de mostrar el mensaje tecnico de `fetch`.
 *
 * `detalles[0]` antes que `message` porque el primero es el error del campo
 * ("Esa categoria no existe") y el segundo el titular generico.
 */
import { ErrorDeApi } from '../servicios/cliente-api';

export function mensajeDe(fallo: unknown): string {
  if (fallo instanceof ErrorDeApi) return fallo.detalles?.[0]?.mensaje ?? fallo.message;
  return 'No pudimos conectarnos con el servidor. Intenta de nuevo.';
}
